// Pantalla `command="login-page-expired"`. Cuando KC detecta que la
// página de login lleva demasiado tiempo abierta y rechaza el submit
// con "page expired". Muestra dos opciones: nueva identificación
// (restartUrl) o continuar con la actual (continueUrl). Si no hay
// loginPageExpired data, fallback a Volver al cliente (popup-aware).

import type { KcData } from "../kcData";
import { PopupAwareBackButton } from "../components/PopupAwareBackButton";
import { StandardPage } from "../components/StandardPage";
import { msg } from "../i18n";

interface LoginPageExpired {
  restartUrl?: string;
  continueUrl?: string;
}

function getLoginPageExpired(data: KcData): LoginPageExpired | undefined {
  return (
    (data.form?.loginPageExpired as LoginPageExpired | undefined) ??
    (data as unknown as { loginPageExpired?: LoginPageExpired })
      .loginPageExpired
  );
}

export interface LoginPageExpiredPageProps {
  data: KcData;
}

export function LoginPageExpiredPage({ data }: LoginPageExpiredPageProps) {
  const expired = getLoginPageExpired(data);

  return (
    <StandardPage page="login-page-expired" data={data}>
      <div className="kc-error-message">
        {expired ? (
          <p>
            <a
              id="restartLogin"
              href={expired.restartUrl}
              role="button"
              className="btn btn-lg btn-block btn-primary"
            >
              {msg("loginRestartButton")}
            </a>
            <a
              id="continueLogin"
              href={expired.continueUrl}
              role="button"
              className="btn btn-lg btn-block btn-default"
            >
              {msg("loginContinueButton")}
            </a>
          </p>
        ) : data.clientBaseUrl ? (
          <p>
            <PopupAwareBackButton href={data.clientBaseUrl} />
          </p>
        ) : (
          <p />
        )}
      </div>
    </StandardPage>
  );
}
